"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validCalcFunction_1 = require("../JSchema/validCalcFunction");
var fnumber_1 = require("../methods/fnumber");
var fmoney_1 = require("../methods/fmoney");
function anyCalc(schema) {
    if (schema.anyCalc !== undefined) {
        return schema.anyCalc;
    }
    if (schema.calc || schema.summary || schema.aggregate) {
        Object.defineProperty(schema, 'anyCalc', {
            value: true
        });
        return true;
    }
    else if (schema.properties) {
        for (var key in schema.properties) {
            if (schema.properties.hasOwnProperty(key)) {
                var isCalc = anyCalc(schema.properties[key]);
                if (isCalc) {
                    Object.defineProperty(schema, 'anyCalc', {
                        value: true
                    });
                    return true;
                }
            }
        }
    }
    else if (schema.items) {
        return anyCalc(schema.items);
    }
    Object.defineProperty(schema, 'anyCalc', {
        value: false
    });
    return false;
}
exports.anyCalc = anyCalc;
// export const wrapSchemaProps = ['maxLength', 'minLength', 'maxItems', 'minItems', 'minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum', 'precision'];
function wrapSchemaProps($schema, internal, type, props) {
    for (var i = 0; i < props.length; i++) {
        var field = props[i];
        if (internal.schema[field] !== undefined) {
            if (typeof internal.schema[field] !== type) {
                wrapSchemaProp($schema, field, internal);
            }
            else {
                $schema[field] = internal.schema[field];
            }
        }
    }
}
exports.wrapSchemaProps = wrapSchemaProps;
function wrapSchemaProp($schema, field, internal, func) {
    var schema = internal.schema;
    internal.needsCalcArgs = true;
    var v = schema[field];
    delete $schema[field];
    // if (self.isSimpleField(v)) {
    if (false) {
        // console.log(field + ' simplefield:', v);
        Object.defineProperty($schema, field, {
            enumerable: true,
            get: function () {
                return this.vm.$options.$ext.$model[v];
            }
        });
    }
    else {
        // console.log(`create valid function`, field, v, internal.parent);
        internal.useComputedModel = true;
        if (schema.cache === undefined) {
            schema.cache = {};
        }
        var ff_1 = schema.cache["schema_" + field];
        if (ff_1 === undefined) {
            ff_1 = validCalcFunction_1.default(v);
            // console.log('calc func', ff.toString());
            schema.cache["schema_" + field] = ff_1;
        }
        internal.computed["schema_" + field] = {
            get: function () {
                // console.log('calc 2', field);
                return ff_1.apply(internal.parent, internal.calcargs);
            }
        };
        if (func) {
            // func(ff.apply(internal.parent, internal.calcargs));
            // internal.watch[`schema_${field}`] = func;
            internal.watch['schema_' + field] = {
                handler: func,
                immediate: true
            };
        }
        // delete $schema[field];
        Object.defineProperty($schema, field, {
            enumerable: true,
            get: function () {
                try {
                    return internal.vm["schema_" + field];
                }
                catch (_a) {
                    return undefined;
                }
            }
        });
    }
}
exports.wrapSchemaProp = wrapSchemaProp;
var msgRegex = {
    minimum: /\{\{minimum\}\}/g,
    maximum: /\{\{maximum\}\}/g,
    exclusiveMaximum: /\{\{exclusiveMaximum\}\}/g,
    exclusiveMinimum: /\{\{exclusiveMinimum\}\}/g,
    multipleOf: /\{\{multipleOf\}\}/g,
    maxLength: /\{\{maxLength\}\}/g,
    minLength: /\{\{minLength\}\}/g,
    maxItems: /\{\{maxItems\}\}/g,
    minItems: /\{\{minItems\}\}/g,
    pattern: /\{\{pattern\}\}/g,
    format: /\{\{format\}\}/g,
    enum: /\{\{enum\}\}/g,
    title: /\{\{title\}\}/g,
    value: /\{\{value\}\}/g
};
var mustacheRegex = /{{([a-z.\[\]\s\?\"\'\:\(\)\+]*)}}/gmi;
function getRuleMessage(internal, rule, value, $schema) {
    // let result = rules[rule];
    // if (result) return result;
    if ($schema === void 0) { $schema = null; }
    $schema = $schema || internal.schema;
    var msg = internal.schema.validationMessages ? internal.schema.validationMessages[rule] : undefined;
    if (msg === undefined) {
        if (rule === 'type') {
            msg = internal.options.validationMessages[internal.schema.type];
        }
        if (msg === undefined) {
            msg = internal.options.validationMessages[rule] || rule;
        }
        // jeśli na starcie było zdefiniowane jako numer to od razu podmień
        if (typeof internal.schema[rule] === 'number') {
            // msg = msg.replace(new RegExp(`{{${rule}}}`, 'g'), schema[rule]);
            msg = msg.replace(msgRegex[rule] || 'rrr', function () { return (internal.schema[rule] === undefined ? '' : fnumber_1.default(internal.schema[rule])); });
        }
        // schema.validationMessages[rule] = msg;
    }
    // zamiana {{maxLength}} na prawdziwą wartość
    return msg.replace(mustacheRegex, function (match, matchrule) {
        switch (matchrule) {
            case 'key': return internal.schema.$key || '';
            case 'title': return $schema.title || internal.schema.$key || '';
            case 'format': return internal.schema.format || '';
            case 'value': return value;
            case 'minimum':
            case 'maximum':
            case 'exclusiveMinimum':
            case 'exclusiveMaximum':
                var svalue = $schema[matchrule];
                if (svalue !== undefined) {
                    if (typeof svalue === 'number') {
                        if (internal.schema.type === 'money') {
                            return fmoney_1.default(svalue);
                        }
                        else {
                            return fnumber_1.default(svalue);
                        }
                    }
                    if (internal.schema.type === 'string' && internal.schema.format === 'date') {
                        if (svalue.length >= 10) {
                            return svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        }
                        else {
                            return svalue;
                        }
                    }
                    return svalue;
                }
                return '';
            default: return $schema[matchrule] || '';
        }
    });
    // msg = msg.replace(msgRegex[rule] || 'rrr', () => ($schema[rule] === undefined ? '' : $schema[rule]));
    // return msg.replace(msgRegex.value, value);
}
exports.getRuleMessage = getRuleMessage;
function initVue(prop, internal) {
    if (internal.needsCalcArgs) {
        if (internal.options.external) {
            internal.calcargs[4] = internal.options.external;
            // console.log('set external', self.external);
        }
        else {
            internal.calcargs[4] = {};
        }
        internal.calcargs[5] = internal.options.schemaMethods;
        internal.calcargs[6] = prop;
        internal.calcargs[0] = prop.$root.$model;
        var dest = prop.$parent;
        if (dest && dest.$parent) {
            internal.calcargs[1] = dest.$parent.$model;
            if (dest.$parent.$parent) {
                internal.calcargs[2] = dest.$parent.$parent.$model;
                if (dest.$parent.$parent.$parent) {
                    internal.calcargs[3] = dest.$parent.$parent.$parent.$model;
                }
                else {
                    internal.calcargs[3] = {};
                }
            }
            else {
                internal.calcargs[2] = internal.calcargs[3] = {};
            }
        }
        else {
            internal.calcargs[1] = internal.calcargs[2] = internal.calcargs[3] = {};
        }
    }
    if (internal.useComputedModel || internal.needsCalcArgs) {
        internal.useComputedModel = true;
        internal.computed.model = {
            get: function () { return prop.getValue(); },
            set: function (newValue) { return prop.setValue(newValue); }
        };
        internal.vm = new internal.options.Vue({
            /*
                  data() {
                      return internal.reactiveData;
                  },
                  */
            computed: internal.computed,
            watch: internal.watch
            // methods: {
            //     mround,
            // },
            // $ext: extraData
        });
    }
    else {
        // internal.vm = internal.options.Vue.observable(internal.reactiveData);
    }
}
exports.initVue = initVue;
//# sourceMappingURL=functions.js.map